function About() {
  return (
    <div>
      <h1>About Me</h1>

      <p>I am a Digital Media Web Design student currently attending the University of Central Florida.
        I am pursuing a bachelor's and I am projected to graduate during summer 2027.
        I am very familiar with photoshopping, digital art, and HTML coding.
        I am currently learning and improving JavaScript and PHP.</p>

      <p>Some interests of mine include digital art, gaming, and writing.</p>
    </div>
  );
}

export default About;